var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Collapse } from "react-collapse";
import { ThemePalette } from "../../../theme/_Types";
import { Div } from "../03-base/Div";
import { Button } from "../05-atoms/Button";
import { Navbar } from "./Navbar";
import { NavbarStack, NavbarStackContent, NavbarStackRight } from "./Navbar/Stack";
import { NavbarTitle } from "./Navbar/Title";
/**
 *
 * @param props
 */
var Card = /** @class */ (function (_super) {
    __extends(Card, _super);
    /**
     *
     * @param props
     */
    function Card(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            expand: !props.defaultCollapsed,
        };
        _this.toggleExpand = _this.toggleExpand.bind(_this);
        return _this;
    }
    Card.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement(Navbar, { theme: {
                    palette: this.props.theme ? this.props.theme.palette : ThemePalette.CONTRAST_TERTIARY,
                }, className: "scl-h-text-align--left" },
                React.createElement(NavbarStack, null,
                    React.createElement(NavbarStackContent, null,
                        React.createElement(NavbarTitle, null, this.props.title)),
                    !!this.props.collapsable && React.createElement(NavbarStackRight, null,
                        React.createElement(Div, { theme: { padding: { "": { x: 2 }, "sm": { x: 3 } } } },
                            React.createElement("div", { style: {
                                    transition: "transform .3s ease",
                                    transform: this.state.expand ? "rotate(-90deg)" : "rotate(0deg)",
                                } },
                                React.createElement(Button, { link: { onClick: this.toggleExpand }, icon: "chevron-left", theme: { palette: ThemePalette.BRAND_ACCENT } })))))),
            React.createElement(Collapse, { isOpened: this.state.expand }, this.props.children || React.createElement(React.Fragment, null))));
    };
    Card.prototype.toggleExpand = function () {
        this.setState({
            expand: !this.state.expand,
        });
    };
    return Card;
}(React.Component));
export { Card };
